import {Component, OnInit, inject} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {Router, NavigationEnd, ActivatedRoute, Data} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';
import {TablerIconsModule} from 'angular-tabler-icons';
import {environment} from '@environment/environment';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterModule, TablerIconsModule, TranslateModule],
  standalone: true,
  templateUrl: './breadcrumb.component.html',
  styleUrls: [],
})
export class AppBreadcrumbComponent {
  // @Input() layout;
  private router: Router = inject(Router);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private titleService: Title = inject(Title);
  private translate: TranslateService = inject(TranslateService);

  pageInfo: Data | any = Object.create(null);
  myurl: any = this.router.url.slice(1).split('/');

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        this.titleService.setTitle(this.translate.instant(event['title']) + environment.second_title);
        this.pageInfo = event;
      });
  }
}
